import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { cropTransactionCommentImage, uploadTransactionCommentImage } from '../../../payment/transaction-actions';
import EditableImageButton from '../../../components/editable-image–button/EditableImageButton';
import Image from '../../../components/image/Image';
import { Icon } from '@sb1/ffe-icons-react';
import close from '@sb1/ffe-icons/icons/open/500/md/close.svg';
import { SecondaryButton } from '@sb1/ffe-buttons-react';
import { showErrorModal } from '../../../global-message/global-message-actions';
import styles from './name-and-comment.module.less';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import {
    ADDING_COMMENT_IMAGE_ERROR_KEY,
    ADDING_COMMENT_IMAGE_NO_IMAGE_KEY,
    ADDING_COMMENT_IMAGE_UPLOADING_IMAGE_KEY,
} from '../../i18n/project-i18n-model';
import { useProject } from '../../project-hooks/useProject';

export const NameAndCommentImage = ({ imageUrl, setImageUrl }) => {
    const [tmpImageUrl, setTmpImageUrl] = useState(null);
    const [uploadId, setUploadId] = useState(null);
    const dispatch = useDispatch();
    const project = useProject();

    const texts = useI18nTexts([
        ADDING_COMMENT_IMAGE_ERROR_KEY,
        ADDING_COMMENT_IMAGE_NO_IMAGE_KEY,
        ADDING_COMMENT_IMAGE_UPLOADING_IMAGE_KEY,
    ]);

    const updateImage = (file) =>
        dispatch(uploadTransactionCommentImage({ projectId: project.id, file })).then((responseBody) => {
            setTmpImageUrl(responseBody.imgTempUrl);
            setUploadId(responseBody.uploadId);
        });

    const cropHandler = (crop) =>
        dispatch(cropTransactionCommentImage({ projectId: project.id, uploadId, crop })).then((responseBody) => {
            setImageUrl(responseBody.imgUrl);
        });

    const dropRejected = (error) => {
        const message = error[0]?.errors?.map((e) => e.message)?.join(', ');
        dispatch(
            showErrorModal(`${texts[ADDING_COMMENT_IMAGE_ERROR_KEY]} ${message ? `(${message.toLowerCase()})` : ''}`)
        );
    };

    if (!imageUrl) {
        return (
            <EditableImageButton
                updateImage={updateImage}
                cropHandler={cropHandler}
                onDropRejected={dropRejected}
                tmpImageUrl={tmpImageUrl}
                imageUrl={imageUrl}
                aspect={4 / 3}
                buttonTask={true}
                isFetchingImageText={texts[ADDING_COMMENT_IMAGE_UPLOADING_IMAGE_KEY]}
                noImageText={texts[ADDING_COMMENT_IMAGE_NO_IMAGE_KEY]}
                className={styles.uploadButton}
            />
        );
    }

    return (
        <div className={styles.imageRemovable}>
            <div className={styles.removeButtonWrapper}>
                <SecondaryButton
                    iconOnly
                    size="md"
                    className={[styles.removeButton, 'ffe-accent-mode'].join(' ')}
                    type={'button'}
                    onClick={() => setImageUrl(null)}
                >
                    <Icon fileUrl={close} size="md" />
                </SecondaryButton>
            </div>
            <Image src={imageUrl} className={styles.image} />
        </div>
    );
};
